/**
 * Хардкод для белатора
 */
export function isBellator(arenaId) {
  return arenaId === "hHto6pN_AyUyBoR13WxP2Cyx7ytYaBpD0RiK6-S5LpM";
}
